import { SharedService } from './../../../services/shared.service';
import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import html2canvas from 'html2canvas';


@Component({
  selector: 'app-phone-record-report',
  standalone: false,
  templateUrl: './phone-record-report.component.html',
  styleUrl: './phone-record-report.component.css'
})
export class PhoneRecordReportComponent {
  public shareObject: any = {};
  constructor(
    public sharedService: SharedService,
    public activatedRoute: ActivatedRoute,
    public form: FormBuilder,
    public translate: TranslateService,
  ) { }
  ngOnInit() {
    // Lấy ngày đầu tháng và ngày cuối tháng
    let startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    let endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    startDate = new Date();
    endDate = new Date();
    if (this.sharedService.env.production === false) {
      startDate = new Date(`2025-04-18`);
      endDate = new Date(`2025-04-18`);
    }

    this.shareObject.filterForm = this.form.group({
      startDate: [startDate.toISOString().split('T')[0]],
      endDate: [endDate.toISOString().split('T')[0]],
      phoneId: [''],
    });
    this.activatedRoute.params.subscribe((params) => {
      // this.shareObject.phoneId = params['id'];
      this.shareObject.filterForm.patchValue({
        phoneId: params['id']
      });
    });
    this.getData();
  }
  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  getData() {
    let payload = {
      phoneId: this.shareObject.filterForm.value.phoneId,
      startDate: new Date(new Date(this.shareObject.filterForm.value.startDate).setHours(0, 0, 0, 0)).getTime(),
      endDate: new Date(new Date(this.shareObject.filterForm.value.endDate).setHours(23, 59, 59, 999)).getTime(),
    }
    this.sharedService.callApi(`/callrecord/report`, payload).subscribe((res: any) => {
      let report = res.data;
      this.shareObject.phone = res.phone;

      // Line chart total count by time
      this.shareObject.lineCtx = document.getElementById('lineChart') as HTMLCanvasElement;
      if (this.shareObject.lineChart) {
        this.shareObject.lineChart.destroy();
      }
      this.shareObject.lineChart = null;
      this.shareObject.lineChart = new Chart(this.shareObject.lineCtx, {
        type: 'line',
        data: {
          labels: report.map((item: any) => {
            if (item._id.includes(' ')) {
              let date = new Date(item._id);
              // change offset to UTC+7
              date.setHours(date.getHours() + 7);
              return date.toLocaleString().split(',').pop();
            }
            return item._id
          }),
          datasets: [{
            label: this.shareObject.phone.holder.profile.name,
            data: report.map((item: any) => item._id).map((e: any) => {
              return report.find((a: any) => a._id == e).count
            }),
            backgroundColor: 'rgb(75, 192, 192)',
            borderColor: 'rgb(75, 192, 192)',
            // borderWidth: 1
          }]
        },
        plugins: [ChartDataLabels],
        options: {
          plugins: {
            datalabels: {
              backgroundColor: 'rgb(75, 192, 192)',
              borderRadius: 4,
              color: 'white',
              font: {
                weight: 'bold'
              },
              formatter: Math.round,
              padding: 6
            }
          },

          // Core options
          aspectRatio: 5 / 3,
          layout: {
            padding: {
              top: 32,
              right: 16,
              bottom: 16,
              left: 8
            }
          },
          elements: {
            line: {
              fill: false,
              tension: 0.4
            }
          },
          scales: {
            y: {
              stacked: true,
              beginAtZero: true,
            }
          }
        }
      });
      this.shareObject.lineChart.update();


      // Pie chart total count by type
      this.shareObject.pieCtx = document.getElementById('pieChart') as HTMLCanvasElement;
      if (this.shareObject.pieChart) {
        this.shareObject.pieChart.destroy();
      }
      this.shareObject.pieChart = null;

      let totalType: any = {
        unknown: 0,
        incoming: 0,
        outgoing: 0,
        missed: 0,
        voicemail: 0,
        rejected: 0,
        blocked: 0,
        answered_externally: 0,
      };
      let colorType: any = {
        unknown: '#bdc3c7',
        incoming: '#2ecc71',
        outgoing: '#4bc0c0',
        missed: '#e74c3c',
        voicemail: '#9b59b6',
        rejected: '#ff6384',
        blocked: '#2c3e50',
        answered_externally: '#ffcd56',
      };
      report.forEach((item: any) => {
        totalType.unknown += item.unknown;
        totalType.incoming += item.incoming;
        totalType.outgoing += item.outgoing;
        totalType.missed += item.missed;
        totalType.voicemail += item.voicemail;
        totalType.rejected += item.rejected;
        totalType.blocked += item.blocked;
        totalType.answered_externally += item.answered_externally;
      });
      let totalTypeArr = Object.keys(totalType).map((key: any) => {
        return {
          type: key,
          color: colorType[key],
          count: totalType[key]
        }
      }).filter((item: any) => item.count > 0);
      this.shareObject.pieChart = new Chart(this.shareObject.pieCtx, {
        type: 'pie',
        data: {
          labels: totalTypeArr.map((item: any) => {
            return this.translate.instant(`call_type_${item.type}`) + ` (${item.count})`;
          }),
          datasets: [{
            label: this.shareObject.phone.holder.profile.name,
            data: totalTypeArr.map((item: any) => item.count),
            backgroundColor: totalTypeArr.map((item: any) => item.color),
            borderColor: totalTypeArr.map((item: any) => item.color),
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label: function (context: any) {
                  let value = parseInt(context?.raw) || 0;
                  let total = parseInt(context.dataset.data.reduce((a: any, b: any) => a + b, 0));
                  let percentage = Math.round((value / total) * 100);
                  return `${value} (${percentage}%)`;
                }
              }
            },
            legend: {
              position: 'top',
            },
            datalabels: {
              formatter: (value, context: any) => {
                let total = parseInt(context.dataset.data.reduce((a: any, b: any) => a + b, 0));
                let percentage = Math.round((value / total) * 100);
                return `${value} (${percentage}%)`;
              },
              color: '#fff',
              font: {
                weight: 'bold',
                size: 14
              }
            }
          }
        },
        plugins: [ChartDataLabels]
      });
      this.shareObject.pieChart.update();



    });
  }
  print() {
    document.querySelector('.dont-print')?.classList.add('d-none');
    let element = document.querySelector('.printArea') as HTMLDivElement;
    html2canvas(element, {
      ignoreElements: (element) => {
        return element.classList.contains('dont-print');
      },
      onclone: (clonedDoc) => {
        console.log(clonedDoc);
      },
      // scale: 2, // Increase the scale for better quality
    }).then((canvas) => {
      // download the image
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = `phone_record_report_${this.shareObject.phone.number}_${new Date().toISOString().split('T')[0]}.png`;
      link.click();
      // remove the class after printing
      document.querySelector('.dont-print')?.classList.remove('d-none');
    });
  }

}
